module.exports = __webpack_public_path__ + "60dea44fd4c762fcf42ed55558e92a7e.MP3";